<div [ngClass]="errorDetailsService.showErrorMsg ? 'list-errors' : 'disappear-list'" class="lists">
    <button (click)="ToggleErrors()" class="x-close">X</button>
    <div class="pb-5">
        <h3 class="error-details">Error Details</h3>
        <div>
            <span>
                {{error?.Title}}
            </span>
        </div>
        <ng-container *ngIf="error?.Details">
            <h3 class="error-details">Details:</h3>
            <div>
                <span>
                    {{error?.Details}}
                </span>
            </div>
        </ng-container>
        <div>
            <div class="circle-container" *ngIf="error?.Parameter">
                <div class="circle"></div><span>Parameter name: {{error?.Parameter}}</span>
            </div>
        </div>
    </div>
</div>